import Uppy from '@uppy/core';
import XHRUpload from '@uppy/xhr-upload';
import { delay } from '../../../lib/helpers.js';

export class UploadManager {
  static uploaders = new Map();

  constructor({ message, endpoint, csrfToken, chatModel }) {
    this.id = message.uuid;
    this.file = message.file;
    this.endpoint = endpoint;
    this.csrfToken = csrfToken;
    this.message = message;
    this.chatModel = chatModel;
    this.uppy = this.findUploader(this.id) || new Uppy();

    this.setupUppy();
    this.setupEvents();
  }

  upload(...args) {
    return this.uppy.upload(...args);
  }

  destroy() {
    this.uppy.close();
  }

  findUploader() {
    return this.constructor.uploaders.get(this.id);
  }

  deleteUploader() {
    return this.constructor.uploaders.delete(this.id);
  }

  registerUploader() {
    return this.constructor.uploaders.set(this.id, this.uppy);
  }

  get uppyUploadOptions() {
    return {
      id: `XHRUpload-${this.id}`,
      endpoint: this.endpoint,
      fieldName: 'file',
      formData: true,
      headers: {
        'X-CSRF-Token': this.csrfToken,
      },
    };
  }

  setupUppy() {
    this.uppy.use(XHRUpload, this.uppyUploadOptions);
    this.registerUploader();

    this.uppy.setMeta({
      message: JSON.stringify(this.message),
    });
    this.uppy.addFile(this.file);
  }

  setupEvents() {
    this.uppy.on('upload-progress', this.handleUploadProgress.bind(this));
    this.uppy.on('complete', this.handleComplete.bind(this));
  }

  calculateProgress(progress) {
    const { bytesTotal, bytesUploaded } = progress;
    return Math.floor((bytesUploaded / bytesTotal) * 100);
  }

  async handleUploadProgress(_file, progress) {
    const { uuid, uploadProgress } = this.message;
    // Add some delay so we see empty progress bar on start
    await delay(!uploadProgress ? 250 : 0);

    this.chatModel.updateMessage({
      uuid,
      uploadProgress: this.calculateProgress(progress),
    });
  }

  handleComplete({ failed }) {
    this.deleteUploader();
    const { uuid } = this.message;
    const errors = failed?.[0]?.response.body.errors;

    this.delayedRevokeObjectURL();

    this.chatModel.updateMessage({
      uuid,
      errors,
      uploading: false,
    });
  }

  // Add some delay so preview sill works until we get the new url from the server
  delayedRevokeObjectURL() {
    setTimeout(() => URL.revokeObjectURL(this.message.imagePreviewUrl), 3000);
  }
}
